export default "__VITE_ASSET__8d80ae17__"